/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Service type:<br />
 * Common - common service<br />
 * Meal - meal service
 * @export
 */
export const TravelineServiceKindDto = {
    Common: 'Common',
    Meal: 'Meal'
} as const;
export type TravelineServiceKindDto = typeof TravelineServiceKindDto[keyof typeof TravelineServiceKindDto];


export function instanceOfTravelineServiceKindDto(value: any): boolean {
    for (const key in TravelineServiceKindDto) {
        if (Object.prototype.hasOwnProperty.call(TravelineServiceKindDto, key)) {
            if (TravelineServiceKindDto[key as keyof typeof TravelineServiceKindDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelineServiceKindDtoFromJSON(json: any): TravelineServiceKindDto {
    return TravelineServiceKindDtoFromJSONTyped(json, false);
}

export function TravelineServiceKindDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineServiceKindDto {
    return json as TravelineServiceKindDto;
}

export function TravelineServiceKindDtoToJSON(value?: TravelineServiceKindDto | null): any {
    return value as any;
}

export function TravelineServiceKindDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelineServiceKindDto {
    return value as TravelineServiceKindDto;
}

